import { BaseFilters } from '@/models/Service';
import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import {
  TeacherLessonRating,
  StudentLessonRating,
  AverageStudentLessonRating,
  AverageTeacherLessonRating,
} from '@/models/LessonRating';

export interface ListLessonRatingParams extends BaseFilters {
  courseId?: Array<number>;
  lessonId?: Array<number>;
  klassId?: Array<number>;
  unitId?: Array<number>;
  courseLineId?: number[];
  userId?: Array<number>;
  lessonRating?: number;
  rating?: Array<number>;
  teacherRating?: number;
  ordering?: 'updated_at' | '-updated_at';
}

export const listTeacherLessonRating = async (
  params: ListLessonRatingParams = {},
) => {
  const { data } = await requester().get<JsonApiResponse<TeacherLessonRating>>(
    `teacher-lesson-rating/`,
    {
      params,
    },
  );
  return data;
};

export const getAverageTeacherLessonRating = async (
  params: ListLessonRatingParams = {},
) => {
  const { data } = await requester().get<AverageTeacherLessonRating>(
    `teacher-lesson-rating/average/`,
    {
      params,
    },
  );
  return data;
};

export const createTeacherLessonRating = async (
  body: Omit<TeacherLessonRating, 'userId' | 'createdAt' | 'id'>,
) => {
  const { data: lessonRating } = await requester().post<TeacherLessonRating>(
    `teacher-lesson-rating/`,
    body,
  );
  return lessonRating;
};

export const updateTeacherLessonRating = async (
  lessonId: number,
  body: Partial<
    Omit<TeacherLessonRating, 'userId' | 'createdAt' | 'id' | 'lessonId'>
  >,
) => {
  const { data: lessonRating } = await requester().patch<TeacherLessonRating>(
    `teacher-lesson-rating/${lessonId}/`,
    body,
  );
  return lessonRating;
};

export const listStudentLessonRating = async (
  params: ListLessonRatingParams = {},
) => {
  const { data } = await requester().get<JsonApiResponse<StudentLessonRating>>(
    `student-lesson-rating/`,
    {
      params,
    },
  );
  return data;
};

export type CreateLessonRatingBody = Omit<
  StudentLessonRating,
  'userId' | 'createdAt' | 'id' | 'klassName'
>;

export const createStudentLessonRating = async (
  body: CreateLessonRatingBody,
) => {
  const { data: lessonRating } = await requester().post<StudentLessonRating>(
    `student-lesson-rating/`,
    body,
  );
  return lessonRating;
};

export type UpdateLessonRatingBody = Partial<
  Omit<StudentLessonRating, 'userId' | 'createdAt' | 'id' | 'lessonId'>
>;

export const updateStudentLessonRating = async (
  lessonId: number,
  body: UpdateLessonRatingBody,
) => {
  const { data: lessonRating } = await requester().patch<StudentLessonRating>(
    `student-lesson-rating/${lessonId}/`,
    body,
  );
  return lessonRating;
};

export const getAverageStudentLessonRating = async (
  params: ListLessonRatingParams = {},
) => {
  const { data } = await requester().get<AverageStudentLessonRating>(
    `student-lesson-rating/average/`,
    {
      params,
    },
  );
  return data;
};
